module.exports = __webpack_public_path__ + "img/newsImg6-2.7b3294ef.png";